import { array, string } from 'yup'

const atLeastOneNumberRegex = /^(?=.*\d).*$/
const atLeastOneLowerCaseRegex = /^(?=.*[a-z]).*$/
const atLeastOneUpperCaseRegex = /^(?=.*[A-Z]).*$/
const atLeastOneSpecialCharRegex = /^(?=.*?[!#$%&*@^]).*$/

export const yup_availability_slots = array()
  .nullable()
  .test(
    'validate availability structure',
    'Availability Time is required',
    original => {
      if (original?.length !== 2) return false
      if (!original.every(value => value instanceof Date)) return false
      return true
    }
  )

export const yup_password_validation = string()
  .matches(atLeastOneLowerCaseRegex, {
    message: 'Password must contain at least one lowercase letter.'
  })
  .matches(atLeastOneUpperCaseRegex, {
    message: 'Password must contain at least one uppercase letter.'
  })
  .matches(atLeastOneNumberRegex, {
    message: 'Password must contain at least one number.'
  })
  .matches(atLeastOneSpecialCharRegex, {
    message: 'Password must contain at least one special character.'
  })
  .min(10, 'Password field must be at least 10 characters in length.')
  .max(50, 'Password field must be less than 50 characters in length.')
  .required('Password field is required.')
